module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/book-75667f098de369fdd7ca967978fb4dc6.png";